import React from "react";
import "./_card.scss";

const Card = ({ icon, title, paragraph }) => {
  return (
    <div className="card_wrapper">
      <div className="card_icon">
        <img src={icon} className="img-fluid" alt="icon" />
      </div>
      <div className="title">
        <h2>{title}</h2>
      </div>
      <div className="description">
        <p>{paragraph}</p>
      </div>
    </div>
  );
};

export default Card;
